export default __webpack_public_path__ + "static/media/bg-together-2.ce1f41c5.png";